import React from "react";
import { useTranslation } from "react-i18next";
import UploadVisionData from "./UploadVisionData";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";
import { debugLogPages } from "../../app/helpers/debugHelper";

const ImportDataVisionScreen = () => {
  debugLogPages(':: ImportDataVisionScreen');

  const { t } = useTranslation();

  return (
    <>
      <NavbarIconsGenericComponent componentName="ImportDataVision" />

      <div className="d-flex justify-content-center page-title">{t("admin.importdata.vision.title")}</div>

      <hr className="line-hr" />

      <div>
        <UploadVisionData />
      </div>

    </>
  );
};

export default ImportDataVisionScreen;
